import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import type { createFiatPayerInput } from '#src/__generated__/globalTypes.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  CreateFiatPayer,
  CreateFiatPayerVariables,
} from './__generated__/useCreatePayer.graphql.ts';

const CREATE_FIAT_PAYER_MUTATION = gql`
  mutation CreateFiatPayer($input: createFiatPayerInput!) {
    createFiatPayer(input: $input) {
      currentUser {
        slug
        myAccounts {
          id
          accountable {
            ... on Node {
              id
            }
            ... on PrivateFiatWalletAccount {
              id
              state
            }
          }
        }
      }
      errors {
        message
        code
        path
      }
    }
  }
` as TypedDocumentNode<CreateFiatPayer, CreateFiatPayerVariables>;

export const useCreatePayer = () => {
  const [createPayer] = useMutation<CreateFiatPayer, CreateFiatPayerVariables>(
    CREATE_FIAT_PAYER_MUTATION,
    {
      showErrorsWithSnackNotification: true,
    }
  );
  const submit = useCallback(
    async (input: createFiatPayerInput) => {
      return await createPayer({
        variables: {
          input,
        },
      });
    },
    [createPayer]
  );
  return [submit];
};
